import VueBaseController from '../vue_base'

export class ShowController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/profiles/show.vue') }
}
